<template>
  <div class="composition-page">
    <chartLoaders v-if="showLoaders == true"></chartLoaders>
    <screen-loader v-if="showLoaders == true"></screen-loader>
    <v-card-text class="chart-table-wrap pa-0" v-else-if="serverItems.length > 0 && showLoaders == false">
      <!-- <v-select
        v-model="selectedSort"
        label="Sort Step Pressure"
        :items="sortOptions"
        @update:modelValue="onSelectSort"
      ></v-select> -->
      <div class="chart-wrap"  v-if="fluidComponentReference">
        <div v-for="(variable, index) in variables" :key="index" class="chart-column" :style="getChartColumnStyle(index)">
          <div class="modal-tab-div">
            <div class="tab-div">
                <p>Y Axis Scale:</p>
                <v-btn-toggle
                    v-model="isYLog[variable]"
                    class="axis-toggle setHeight"
                    ref="yAxisToggle"
                    mandatory
                    @update:modelValue="handleYScaleToggleChange(variable)"
                  >
                  <v-btn :value="true" class="switch-btn" outlined>Log</v-btn>
                    <v-btn :value="false" class="switch-btn" outlined>Linear</v-btn>
                  </v-btn-toggle>
            </div>
          </div>
          <div class="chart-name-top">
          <h6>{{getHeaderDisplayNameChartTitle(variable) }} </h6>
          </div>
          <div :ref="`chart-${index}`" class="main-chart">
          </div>

          <v-dialog v-model="isPreviewOpen[index]" class="multi-chart-preview-div dashboard-chart-preview composition">
            <v-card class="position-relative studio-card">
              <v-card-text>
                <div class="popup-top">
                  <div class="modal-tab-div">
            <div class="tab-div">
                <p>Y Axis Scale:</p>
                <v-btn-toggle
                    v-model="isModalYLog[index]"
                    class="axis-toggle setHeight"
                    mandatory
                    @update:modelValue="handleModalYScaleToggleChange(index)"
                  >
                  <v-btn :value="true" class="switch-btn" outlined>Log</v-btn>
                    <v-btn :value="false" class="switch-btn" outlined>Linear</v-btn>
                  </v-btn-toggle>
            </div>
          </div>
                  <div class="chart-name-top w-100">
                    <h6>{{getHeaderDisplayNameChartTitle(variable)}}</h6>
                  </div>
                  <!-- <img :src="cross" alt="cross" @click="closeModal(index)" class="chart-preview-close-btn"> -->
                </div>
                <div :ref="`modal-chart-${index}`" class="modal-chart-container"></div>
              </v-card-text>
            </v-card>
          </v-dialog>
        </div>
      </div>
      <div v-else-if="!fluidComponentReference" class="text-center pt-1 pb-5">
        <h4>Charts couldn't be plotted as fluid component reference is not available in this test.</h4>
      </div>
      <div class="table-wrap">
        <div class="table-title-div" v-if="serverItems.length > 0">
          <p class="table-title">Residual Oil Compositions</p>
          <div class="csv-btn" @click="downloadTableCSV">
            <v-img class="pointer" :src="documentDownload" alt="csv download"></v-img>
          </div>
        </div>
        <v-data-table :headers="headers" :items="serverItems" :total-items="totalItems" :items-per-page="itemsPerPage"
          :loading="loading" :search="search" :item-value="name" virtual-items fixed-header max-height="calc(100vh - 380px)">
          <template v-slot:headers>
            <tr class="main-header">
              <th v-for="(header, index) in headers" :key="index" class="sticky-header">
                {{ header.displayLabel || header.name }}
                <span @click="handleHeaderClick(header.key)">
                  <span v-if="header.key === 'stepPressure'">
                    <v-icon v-if="sortOrder === 'asc'" @click.stop="sortStepPressure('desc')"
                      small>mdi-arrow-down</v-icon>
                    <v-icon v-else @click.stop="sortStepPressure('asc')" small>mdi-arrow-up</v-icon>
                  </span>
                </span>
              </th>
            </tr>
            <tr class="sub-header">
              <th v-for="(header, index) in headers" :key="index">
                {{ getCompositionTableUnitDisplay(header) }}
              </th>
            </tr>
          </template>
          <template v-slot:body="{ items }">
            <tr v-for="(item, index) in items" :key="index">
              <td v-for="(header, headerIndex) in headers" :key="headerIndex">
                <template v-if="header.key === 'saturationPressure'">
                  <template v-if="index === 0">{{ displayValue(header.key, item[header.key]) }}</template>
                  <template v-else>-</template>
                </template>
                <template v-else>
                  {{ displayValue(header.key, item[header.key]) !== null ? displayValue(header.key, item[header.key]) :
                    '-'
                  }}
                </template>
              </td>
            </tr>
          </template>
          <template v-slot:body.append>
            <tr class="total-row">
              <td v-for="(header, headerIndex) in headers" :key="headerIndex">
                <template v-if="headerIndex === 0">Total</template>
                <template v-else>
                  <span v-if="header.key.includes('MassFraction') && toggleFraction">
                    {{ sums[header.key] ? truncateNumber(sums[header.key], 3) : "-" }}
                  </span>
                  <span v-if="header.key.includes('MoleFraction') && !toggleFraction">
                    {{ sums[header.key] ? truncateNumber(sums[header.key], 3) : "-" }}
                  </span>
                  <span v-if="!header.key.includes('MassFraction') && !header.key.includes('MoleFraction')">-</span>
                </template>
              </td>
            </tr>
          </template>
        </v-data-table>
      </div>
    </v-card-text>
    <div v-else-if="(!serverItems || serverItems.length === 0) && showLoaders == false" class="tabs-no-test-div">
      <h4>No data available.</h4>
    </div>
  </div>
</template>

<script>
import Plotly from "plotly.js-dist-min";
import ChartLoaders from "../Loaders/ChartLoaders.vue";
import ScreenLoader from "../Loaders/ScreenLoader.vue";
import axios from "axios";
import { getDisplayName, getSortOrder  } from '../../../utils/cache';
import { mapGetters } from "vuex";
import downloadIcon from '../../../assets/Svg/Chart/csv_chart.svg';
import camIcon from '../../../assets/Svg/camIcon.svg';
import Expand from "../../../assets/Svg/Chart/expand-btn.svg";
import {  chartGridColor , INDIVIDUAL_TEST_MARKER_SIZE } from "@/utils/chartTheme";
import { downloadPlotlyAsPng } from "@/utils/plotlyPngDownload";
import {
  applyScatterModalYAxisScale,
  buildSimpleScatterLogYAxisConfig,
  estimateRotatedCategoryBottomMargin,
  getCompositionChartColumnHeight,
} from "@/utils/plotlyLogAxis";
import { getTenantPrefix } from "@/utils/tenant";
import {
  formatChartAxisLabelPlain,
  getCompositionTableUnitDisplay,
  getPlotlyAxisTitleText,
  resolveChartHeaderUnit,
  sanitizeChartExportFileName,
} from "@/utils/chartAxisUtils";


export default {
  name: "ResidualOilCompositon",
  components: {
    ChartLoaders,
    ScreenLoader,
  },
  data: () => ({
    showLoaders: true,
    documentDownload: require("../../../assets/Images/csv.svg"),
     cross: require("../../../assets/Svg/Chart/chart-cross.svg"),
    itemsPerPage: 0,
    headers: [],
    serverItems: [],
    loading: true,
    totalItems: 0,
    variables: ["1", "2"],
    isPreviewOpen: Array().fill(false),
    chartData: Array().fill(null),
    cachedData: {},
    testID: "",
    testName: "",
    sampleID: "",
    fluidComponentReference: false,
    saturationPressure: "",
    saturationPressure_UOM: "",
    testTemperature: "",
    testTemperature_UOM: "",
    toggleFraction: true,
    sortOrder: 'desc',
    yAxisScales: {},
    isYLog: {},
    modalYAxisScales: {},
    isModalYLog: {},
    sepTestHeadersResid:{},
    sums: {},
    chartColumnHeights: {},
  }),
  computed: {
    tenantId() {
      return getTenantPrefix() || "";
    },
    ...mapGetters("darkMode", ["isDarkMode"]),
  },
  methods: {
    getChartColumnStyle(index) {
      const height = this.chartColumnHeights[index];
      return height ? { height: `${height}px` } : {};
    },
    truncateNumber(value, decimals) {
      const factor = Math.pow(10, decimals);
      const truncatedValue = Math.floor(value * factor) / factor;
      return truncatedValue.toFixed(decimals);
    },
    
    calculateSums() {
      const sums = {};

      this.headers.forEach((header) => {
        if (header.key.includes("MassFraction") && this.toggleFraction) {
          sums[header.key] = this.serverItems.reduce((sum, item) => {
            return sum + (parseFloat(item[header.key]) || 0);
          }, 0);
        } else if (
          header.key.includes("MoleFraction") &&
          !this.toggleFraction
        ) {
          sums[header.key] = this.serverItems.reduce((sum, item) => {
            return sum + (parseFloat(item[header.key]) || 0);
          }, 0);
        }
      });

      this.sums = sums;
    },
    

    handleYScaleToggleChange(variable) {
    if (this.yAxisScales[variable] === undefined) {
      this.yAxisScales[variable] = 'linear';
    }

      this.yAxisScales[variable] = this.isYLog[variable] ? "log" : "linear";

    const chartIndex = this.variables.indexOf(variable);

    this.modalYAxisScales[chartIndex] = this.yAxisScales[variable];
    if(this.modalYAxisScales[chartIndex] === "log") {
      this.isModalYLog[chartIndex] = true;
    }
    else {
this.isModalYLog[chartIndex] = false;
    }
    if (this.cachedSeparatorTest) {
      this.plotChartForVariable(variable, chartIndex, this.cachedSeparatorTest);
    }
  },
  handleModalYScaleToggleChange(index) {
    if (this.modalYAxisScales[index] === undefined) {
      this.modalYAxisScales[index] = 'linear';
    }

      this.modalYAxisScales[index] = this.isModalYLog[index] ? "log" : "linear";

      this.plotModalChart(index)
  },
    sortStepPressure(order) {
      this.sortOrder = order;
      if (order === 'asc') {
        this.serverItems.sort((a, b) => a.stepPressure - b.stepPressure);
      } else {
        this.serverItems.sort((a, b) => b.stepPressure - a.stepPressure);
      }
    },
    toggleFractionFunction() {
      this.serverItems = [];
      if (this.loading == true && this.serverItems.length == 0) {
        this.showLoaders = true;
      }
      this.chartPlotted();
      this.$emit('toggleFraction', this.toggleFraction);
    },
    downloadChartCSV(index) {
      const chartData = this.chartData[index];

      if (chartData) {
        const yAxisLabel = chartData.yAxisLabel
          || getPlotlyAxisTitleText(chartData.layout?.yaxis?.title)
          || "Chart";
        const xAxisLabel = chartData.xAxisLabel
          || getPlotlyAxisTitleText(chartData.layout?.xaxis?.title)
          || "Component";
        const fileName = `${sanitizeChartExportFileName(yAxisLabel)} vs ${sanitizeChartExportFileName(xAxisLabel)} data.csv`;

        const csvHeader = [xAxisLabel, yAxisLabel];

        const csvRows = chartData.trace.x.map((xValue, i) => [xValue, chartData.trace.y[i]]);

        const csvContent = [csvHeader.join(','), ...csvRows.map(row => row.join(','))].join('\n');

        const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });

        const link = document.createElement('a');
        if (link.download !== undefined) {
          const url = URL.createObjectURL(blob);
          link.setAttribute('href', url);
          link.setAttribute('download', fileName); // Set filename
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        } else {
          console.error('Your browser does not support downloading files programmatically. Please try a different browser.');
        }
      }
    },

    downloadTableCSV() {
      if (this.serverItems && this.serverItems.length > 0) {
        const fileName = "residual_oil_compositions_table.csv";

        const csvHeader = this.headers.map((header) => header.displayLabel || header.name);
        const csvUnits = this.headers.map((header) => getCompositionTableUnitDisplay(header));

        const csvRows = this.serverItems.map((item) =>
          this.headers.map((header) => item[header.key])
        );

        const csvContent = [
          csvHeader.join(","),
          csvUnits.join(","),
          ...csvRows.map((row) => row.join(",")),
        ].join("\n");

        const blob = new Blob([csvContent], {
          type: "text/csv;charset=utf-8;",
        });

        const link = document.createElement("a");
        if (link.download !== undefined) {
          const url = URL.createObjectURL(blob);
          link.setAttribute("href", url);
          link.setAttribute("download", fileName); // Set filename
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        } else {
          console.error(
            "Your browser does not support downloading files programmatically. Please try a different browser."
          );
        }
      } else {
        console.error("No data available in the table to download.");
      }
    },

    async loadItems() {
      var sampleId = this.$route.params.sampleId;
      var separatorId = this.$route.params.id;
      this.loading = true;
      this.showLoaders = true;

      try {
        let response = await axios.get(
          process.env.VUE_APP_API_URL +
          `public/api/samples/${sampleId}/separatortests/${separatorId}`,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("authToken")}`,
              "X-TenantID": this.tenantId,
            },
          }
        );
        if (response && response.data && (response.data.statusCode === 200 || response.data.statusCode === 201)) {
        this.cachedSeparatorTest = response.data.data.separatortest;
        this.serverItems = response.data.data.separatortest && response.data.data.separatortest.separatorResidComposition ? response.data.data.separatortest.separatorResidComposition : [];
        this.totalItems = response.data.data.separatortest && response.data.data.separatortest.length ? response.data.data.separatortest.length : 0;
        this.testID = response.data.data.separatortest.ID
        this.testName = response.data.data.separatortest.name
        this.sampleID = response.data.data.separatortest.sampleID
        this.saturationPressure = response.data.data.separatortest.saturationPressure
        this.saturationPressure_UOM = response.data.data.separatortest.saturationPressure_UOM
        this.testTemperature = response.data.data.separatortest.testTemperature
        this.testTemperature_UOM = response.data.data.separatortest.testTemperature_UOM
        this.sepTestHeadersResid =  response.data.data.pageData.separatorTestResidComponentHeader;
        this.sendDataToParent();



        const sortByKeys = await getSortOrder("separatortests", "separatorTest_resid_component", this.toggleFraction ? "table_for_mass" : "table_for_mole");

        this.fluidComponentReference = this.serverItems.some(item => item.hasOwnProperty('fluidComponentReference'));

        const availableKeys = new Set(
          sortByKeys.filter((key) =>
            this.serverItems.some((item) => key in item)
          )
        );


        const allKeys = sortByKeys.filter((key) => availableKeys.has(key));

        this.variables = Array.from(allKeys).filter(
          (key) =>
            (key !== "stepPressure" &&
              key !== "stepNumber" &&
              key !== "stepTemperature" &&
              this.toggleFraction == true &&
              key.includes("MassFraction")) ||
            (this.toggleFraction == false && key.includes("MoleFraction"))
        );

        const allUniqueKeys = Array.from(allKeys);

        const displayNames = [];
        const digitsArray = [];
        const defaultUoms = [];

        await Promise.all(
  allUniqueKeys.map(async (key) => {
    const fullKey = `separatorResidComposition${key}`; // Concatenate at start
    const capitalizedKey = fullKey.charAt(0) + fullKey.slice(1);
    const { displayName, digits, defaultUOM } = await getDisplayName("separatortests", capitalizedKey);
    displayNames.push(displayName);
    digitsArray.push(digits);
    defaultUoms.push(defaultUOM);
  })
);
        this.headers = Array.from(allKeys).map((key, index) => {
          const uom = this.serverItems.find((item) => item[key + "_UOM"]);
          const name = displayNames[index]; // Use display name instead of key
          const unit = resolveChartHeaderUnit(
            key,
            uom ? uom[key + "_UOM"] : null,
            defaultUoms[index]
          );
          const digits = digitsArray[index] || 0;
          const displayLabel = formatChartAxisLabelPlain(name, unit);
          return {
            key: key,
            name: name,
            unit: unit,
            displayLabel,
            digits: digits,
          };
        });

        this.calculateSums(); // Calculate sums after data is loaded
        return response.data.data.separatortest;
      }
      else if (response && response.data && response.data.message) {
          console.error(response.data.message);
          }
      else {
      console.error("Error in fetching data");
    }
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        this.loading = false;
        this.showLoaders = false;
      }
    },

    async plotChartForVariable(variable, chartIndex, separatortest) {
      if (!separatortest || !separatortest.separatorResidComposition) {
        return;
      }

      const header = this.headers.find(header => header.key === variable);
      const digits = header ? header.digits : 0;

      const filteredComposition = separatortest.separatorResidComposition
        .filter(
          step =>
            step.fluidComponentReference !== 'H2' && // Exclude "H2"
            step.fluidComponentReference &&         // Ensure x is valid
            step[variable] !== undefined &&         // Ensure y is not undefined
            step[variable] !== null                 // Ensure y is not null
        );

      const fluidComponents = filteredComposition.map(step => step.fluidComponentReference);
      const axisType = this.yAxisScales[variable] || "linear";
      const yValues = filteredComposition.map((step) => {
        const numericValue = Number(step[variable]);
        if (!Number.isFinite(numericValue)) {
          return null;
        }
        if (axisType === "log" && numericValue <= 0) {
          return null;
        }
        return numericValue;
      });

      this.chartColumnHeights[chartIndex] = getCompositionChartColumnHeight(fluidComponents);
      const bottomMargin = estimateRotatedCategoryBottomMargin(fluidComponents);

      const trace = {
        x: fluidComponents,
        y: yValues,
        type: "scatter",
        mode: "lines+markers",
        name: variable,
        line: {
          color: "#2199A8",
          width: 2
        },
        marker: {
          color: "#2199A8",
          size: INDIVIDUAL_TEST_MARKER_SIZE,
          line: {
            color: "#2199A8",
            width: 1
          }
        },
        connectgaps: false,
        hovertemplate: `%{x}<br>%{y:.${digits}f}<extra></extra>`,
      };

      const yAxisLabel = this.getHeaderDisplayNameChartTitle(variable);

      const layout = {
        xaxis: {
          title: {
            text: "Component",
            standoff: 8,
          },
          gridcolor: chartGridColor(this.isDarkMode),
          tickangle: -45,
          tickfont: {
            size: 10,
          },
          automargin: false,
        },
        yaxis: buildSimpleScatterLogYAxisConfig(axisType, {
          title: {
            text: yAxisLabel,
            standoff: 20
          },
          gridcolor: chartGridColor(this.isDarkMode),
          yValues,
        }),
        margin: {
          l: 85,
          r: 0,
          b: bottomMargin,
        },
      };

      const config = {
        responsive: true,
        displaylogo: false,
        displayModeBar: true,
        modeBarButtonsToRemove: ['lasso2d', 'select2d', 'pan2d', "resetscale", "zoom", "toImage"],
        modeBarButtonsToAdd: [
          {
            name: "Expand",
            icon: {
              svg: `
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                  <image href="${Expand}" width="24" height="24"/>
                </svg>
              `,
            },
            click: this.openModal.bind(this, chartIndex),
          },
          {
            name: 'Download CSV',
            icon: {
              svg: `
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                  <image href="${downloadIcon}" width="24" height="24"/>
                </svg>
              `,
            },
            click: this.handleDownloadCSV.bind(this, chartIndex)
          },
          {
            name: "Download plot as a png",
            icon: {
              svg: `
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                  <image href="${camIcon}" width="24" height="24"/>
                </svg>
              `,
            },
            click: this.handleDownloadPNG.bind(this, chartIndex),
          },
        ],
      };

      this.chartData[chartIndex] = {
        trace: trace,
        layout: layout,
        config: config,
        yAxisLabel,
        xAxisLabel: "Component",
      };

      const chartRef = this.$refs["chart-" + chartIndex];
      if (chartRef && chartRef.length > 0) {
        const chartElement = chartRef[0];
        Plotly.newPlot(chartElement, [trace], layout, config);
      } else {
        return;
      }
    },

    getHeaderDisplayName(variable) {
      return this.getHeaderDisplayNameChartTitle(variable);
    },
    getHeaderDisplayNameChartTitle(variable) {
      const header = this.headers.find((item) => item.key === variable);
      if (header) {
        return header.displayLabel || formatChartAxisLabelPlain(header.name, header.unit);
      }
      return variable;
    },
    getCompositionTableUnitDisplay(header) {
      return getCompositionTableUnitDisplay(header);
    },
    handleDownloadCSV(chartIndex) {
      this.downloadChartCSV(chartIndex);
    },

    handleDownloadPNG(chartIndex) {
      this.downloadChartPNG(chartIndex);
    },

    downloadChartPNG(index) {
      const chartElement = this.$refs[`chart-${index}`];
      if (!chartElement?.[0]) return;
      const chartData = this.chartData[index];
      const yAxisLabel = chartData?.yAxisLabel
        || getPlotlyAxisTitleText(chartData?.layout?.yaxis?.title)
        || `Chart ${index}`;
      const xAxisLabel = chartData?.xAxisLabel
        || getPlotlyAxisTitleText(chartData?.layout?.xaxis?.title)
        || "Component";
      const fileName = `${sanitizeChartExportFileName(yAxisLabel)} vs ${sanitizeChartExportFileName(xAxisLabel)}`;
      downloadPlotlyAsPng([chartData.trace], chartData.layout, fileName, {
        isDarkMode: this.isDarkMode,
        title: fileName,
      });
    },

    displayValue(key, value) {
      const header = this.headers.find(header => header.key === key);
      const digits = header ? header.digits : 0; // Get digits from header

      if (value !== null && value !== undefined) {
        if (typeof value === 'string') {
          return value;
        } else {
          const numValue = Number(value);
          if (!isNaN(numValue)) {
            return digits > 0 ? numValue.toFixed(digits) : value;
          }
        }
      } else {
        return "-";
      }
    },

    openModal(index) {
      this.isPreviewOpen[index] = true;
      this.$nextTick(() => {
        this.plotModalChart(index);
      });
    },

    closeModal(index) {
      this.isPreviewOpen[index] = false;
    },
    plotModalChart(index) {
      const chartData = this.chartData[index];
      if (chartData) {
        const modalChartRef = this.$refs[`modal-chart-${index}`][0];
        const axisType = this.modalYAxisScales[index] || "linear";
        const modalTrace = {
          ...chartData.trace,
          y: chartData.trace.y.map((value) => {
            const numericValue = Number(value);
            if (!Number.isFinite(numericValue)) {
              return null;
            }
            if (axisType === "log" && numericValue <= 0) {
              return null;
            }
            return numericValue;
          }),
          connectgaps: false,
        };
        const modalLayout = applyScatterModalYAxisScale(chartData.layout, axisType, modalTrace.y);

        Plotly.Plots.resize(modalChartRef);
        Plotly.newPlot(
          modalChartRef,
          [modalTrace],
          modalLayout,
          chartData.config
        );
      }
    },
    async sendDataToParent() {
      const rawHdr = this.sepTestHeadersResid || [];
      const sortOrder = await getSortOrder("separatortests", "separatorTest_resid_component", "header");
      const headerData = [];

      for (const header of rawHdr) {
        if (!header || !header.key) continue;

        let value = header.value || "-";

        const capKey = header.key.charAt(0) + header.key.slice(1);
        let displayName, digits;
        try {
          const result = await getDisplayName("separatortests", capKey);
          displayName = result.displayName;
          digits = result.digits;
        } catch (e) {
          displayName = undefined;
          digits = undefined;
        }

        if (!displayName) {
          displayName = header.key;
        }

        headerData.push({
          originalKey: header.key,
          value: value,
          displayName: displayName,
          digits: digits ? digits : 0,
          unit: "", // Unit is now part of the value string
        });
      }
      this.$emit("data-updated", {
        sepTestProperties: headerData,
        sortOrder,
        originalData: rawHdr,
      });
    },
    chartPlotted() {
      this.loadItems().then((ccetest) => {
        const variablesToPlot = [];
        if (this.toggleFraction == true) {
          variablesToPlot.push(
            "liquid_MassFraction"
          );
        }
        if (this.toggleFraction == false) {
          variablesToPlot.push(
            "liquid_MoleFraction"
          );
        }

        if (
          JSON.stringify(variablesToPlot) !==
          JSON.stringify(this.variablesToPlot)
        ) {
          this.variablesToPlot = variablesToPlot; // Update the tracked variables to plot
          this.plotCharts(variablesToPlot, ccetest); // Plot charts only for the variables enabled by the toggle switches
        }

        variablesToPlot.forEach((variable, index) => {
          this.isYLog[variable] = false;
        this.isModalYLog[index] = false;
          this.plotChartForVariable(variable, index, ccetest);
        });
      });
    },
    plotCharts(variablesToPlot, ccetest) {
      variablesToPlot.forEach((variable, index) => {
        this.plotChartForVariable(variable, index, ccetest);
      });
    },
  },
  watch: {
    serverItems: {
      handler(newItems) {
        this.calculateSums(); // Call calculateSums when serverItems change
      },
      deep: true,
    },
    toggleFraction(newVal, oldVal) {
      this.calculateSums(); // Recalculate sums when fraction type changes
    },
    $route(to, from) {
      this.loadItems()
        .then((separatortest) => {
          this.variables.forEach((variable, index) => {
            this.plotChartForVariable(variable, index, separatortest);
          });
        })
        .catch((error) => {
          console.error("Error loading data:", error);
        });
    },
    isDarkMode() {
      this.loadItems().then((separatortest) => {
        this.variables.forEach((variable, index) => {
          this.plotChartForVariable(variable, index, separatortest);
        });
      });
    }
  },
  mounted() {
    this.chartPlotted();
    
  },
};
</script>

<style scoped>
.total-row {
  background-color: #f5f5f5 !important;
  font-weight: bold;
}

.total-row td {
  font-weight: bold;
}
</style>